import { API_VERSION, TASK_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_EMAILS = `${TASK_SERVICE}/emails`;

export const emails = {
  getByActivityId: async ({ activityId }) => {
    const options = await apiOptions({
      url: `${API_EMAILS}/by-activity/${activityId}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
};
